"use strict";

// Check if DOM is already ready
if (document.readyState === 'loading') {
	// DOM is still loading, so add event listener
	document.addEventListener('DOMContentLoaded', initClosureRedirect);
} else {
	// DOM is already ready, execute immediately
	initClosureRedirect();
}

function initClosureRedirect() {
	//const automatorClosureCookie = 'automator_closure_redirect_' + automatorClosure.nonce;
	const automatorClosureCookie = 'automator_closure_redirect';

	const linkId = 'automator-closure-redirect';

	// Create a hidden campaign link
	let link = createLink(linkId);

	// Wait for the cookie from PHP
	const automatorRedirectTimeout = setInterval(checkCookie, 250);

	function createLink(id) {
		const a = document.createElement('a');
		a.id = id;
		a.style.display = 'none';
		a.rel = "noopener noreferrer"; // Enhance security for external links
		document.body.appendChild(a);
		return a;
	}

	function checkCookie() {
		if (document.hidden) {
			return;
		}

		const redirectURL = getCookie(automatorClosureCookie);
		if (redirectURL && isValidUrl(redirectURL)) { // Check if the URL is valid
			deleteCookie(automatorClosureCookie);
			link.href = redirectURL;
			link.click();
		}
	}

	function isValidUrl(string) {
		// Directly accept '/' as a valid URL or start with '/' for relative URLs
		if (string === '/' || string.startsWith('/')) return true;

		try {
			new URL(string);
			return true; // The URL is valid
		} catch (_) {
			return false; // The URL is not valid
		}
	}

	function getCookie(cname) {
		const name = `${cname}=`;
		const decodedCookie = decodeURIComponent(document.cookie);
		const ca = decodedCookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i].trim();
			if (c.indexOf(name) === 0) {
				return c.substring(name.length);
			}
		}
		return "";
	}

	function deleteCookie(cname) {
		document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
	}
}
